// extracted by mini-css-extract-plugin
export default {"wrap":"AppLayoutMinimal_wrap__XInel","logo":"AppLayoutMinimal_logo__EC+gm"};